/* globals window $ */

import events from './events';
import toggleClass from '../../../utils/toggleClass';
import matchBreakpoint from '../../../utils/matchBreakpoint';
import '../../../utils/resizeEnd';

/**
 * DateScroller
 * @param {Element} element
 * @return {Object}
 */
const dateScroller = (element) => {
  const list = element.querySelector('[data-js-dateScroller-list]');
  const items = [...element.querySelectorAll('[data-js-dateScroller-item]')];
  const prevButton = element.querySelector('[ data-js-dateScroller-prevButton]');
  const nextButton = element.querySelector('[ data-js-dateScroller-nextButton]');

  const $window = $(window);
  const $element = $(element);
  const $items = $(items);
  const $prevButton = $(prevButton);
  const $nextButton = $(nextButton);

  let currentIndex;

  /**
   * Constructor
   */
  function constructor() {
    bindEvents();
  }

  /**
   * Bind handlers to events
   */
  function bindEvents() {
    $element.on(events.SET_DATE, onSetDate);
    $items.on('click', '[data-js-dateScroller-button]', onDateClick);
    $prevButton.on('click', onPrevClick);
    $nextButton.on('click', onNextClick);
    $window.on('resizeEnd', onResizeEnd);

    window.addEventListener('hashchange', onHashChange);
  }

  /**
   * Hash change event handler
   */
  function onHashChange() {
    const hashDate = window.location.hash.split('#').join('');
    const selectedItem = findItem(items, currentIndex);

    // only execute when the browsers back button is used
    if (hashDate !== selectedItem.getAttribute('data-date')) {
      const itemIndex = items.findIndex(item => item.getAttribute('data-date') === hashDate);

      scrollTo(itemIndex, true);
    }
  }

  /**
   * Set date event handler
   * @param {Event} event
   * @param {Object} eventData
   */
  function onSetDate(event, { date }) {
    const item = items.find(item => item.getAttribute('data-date') === date);
    const itemIndex = getItemIndex(item || items[0]);

    scrollTo(itemIndex);
  }

  /**
   * Date selected
   * @param {Element} item
   */
  function dateSelected(item) {
    if (!item) {
      return;
    }

    const date = item.getAttribute('data-date');

    $element.trigger(events.DATE_SELECTED, { date });
    items.forEach(item => toggleClass(item, '_is_active', false));
    toggleClass(item, '_is_active', true);
    currentIndex = getItemIndex(item);
  }

  /**
   * Date click event handler
   * @param {Event} event
   */
  function onDateClick(event) {
    const item = event.delegateTarget;
    dateSelected(item);
  }

  /**
   * Scroll to given index
   * @param {int} index
   * @param {Boolean} doSelectDate
   */
  function scrollTo(index, doSelectDate = true) {
    const listWidth = list.offsetWidth;
    const newX = getNewX(index, listWidth);
    const bounds = getBounds(listWidth, items);

    if (newX >= bounds.min && newX <= bounds.max) {
      items.forEach(item => (item.style.transform = `translateX(${newX}px)`));

      if (doSelectDate) {
        const item = findItem(items, index);

        dateSelected(item);
        window.location.hash = item.getAttribute('data-date');
      }
    }
  }

  /**
   * Prev click event handler
   * @param {Event} event
   */
  function onPrevClick(event) {
    event.preventDefault();
    scrollTo(currentIndex - getNumItemsToShift());
  }

  /**
   * Next click event handler
   * @param {Event} event
   */
  function onNextClick(event) {
    event.preventDefault();
    scrollTo(currentIndex + getNumItemsToShift());
  }

  /**
   * Resize end event handler
   */
  function onResizeEnd() {
    scrollTo(currentIndex, false);
  }

  /**
   * Returns if we are looking at a mobile view
   * @return {Boolean}
   */
  function isMobileView() {
    return !matchBreakpoint('xsmall');
  }

  /**
   * Get scroll bounds
   * @param {Number} width
   * @param {Array} items
   * @return {Object}
   */
  function getBounds(width, items) {
    return {
      min: -(width * (isMobileView() ? items.length - 1 : 1)),
      max: 0,
    };
  }

  /**
   * Returns the new x position
   * @param {int} index
   * @param {Number} width
   * @return {Number}
   */
  function getNewX(index, width) {
    return -((Math.floor(index / (isMobileView() ? 1 : 7))) * width);
  }

  /**
   * Returns the number of items to shift
   * @return {int}
   */
  function getNumItemsToShift() {
    return isMobileView() ? 1 : 7;
  }

  /**
   * Returns an item based on the given index
   * @param {Array} items
   * @param {int} index
   * @return {Element}
   */
  function findItem(items, index) {
    return items.find(item => getItemIndex(item) === index);
  }

  /**
   * Returns the given item's index
   * @param {Element} item
   * @return {int}
   */
  function getItemIndex(item) {
    return parseInt(item.getAttribute('data-index'), 10);
  }

  constructor();

  return {};
};

export default dateScroller;



// WEBPACK FOOTER //
// ./resources/assets/js/specifics/inventoryOverview/dateScroller/dateScroller.js